import nodePathFromArray from 'utils/nodePathToArray'

export default function copyUploadToFiles({ props, state }) {
  const { clientId, id } = state.get('media.currentUpload')
  let { name, size, node, path } = state.get(`media.uploading.${clientId}`)
  let preview = null
  const paths = nodePathFromArray(path)
  paths.splice(paths.indexOf(node), 1) // removes current node from list
  state.merge(`media.uploading.${clientId}`, { moved: true, fileId: id })
  if (node === state.get('node.selectedNode.id')) {
    state.set(`media.files`, {
      [id]: {
        id,
        name,
        size,
        preview,
        node: {
          id: node,
          paths: paths
        },
        addedAt: +new Date()
      },
      ...state.get('media.files')
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/copyUploadToFiles.js